import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  LOGO_IMAGE_INPUT: `${cleanedFilename(__filename)}-logo-image-input`,
  LOGO_CONTAINER: `${cleanedFilename(__filename)}-logo-container`,
  OFFICE_IMAGE_INPUT: `${cleanedFilename(__filename)}-office-image-input`,
  BACKGROUND_IMAGE_INPUT: `${cleanedFilename(__filename)}-background-image-input`,
};
